import { render } from "./PerColorApprovalBadge.vue?vue&type=template&id=18966b8a&scoped=true"
import script from "./PerColorApprovalBadge.vue?vue&type=script&lang=js"
export * from "./PerColorApprovalBadge.vue?vue&type=script&lang=js"

import "./PerColorApprovalBadge.vue?vue&type=style&index=0&id=18966b8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18966b8a"]])

export default __exports__